import { ReactComponent as LogoSvg } from "@/assets/icons/logo-in-circle-white.svg";
import { ReactComponent as QuotesEndSvg } from "@/assets/icons/quotes_end.svg";
import { ReactComponent as QuotesStartSvg } from "@/assets/icons/quotes_start.svg";
import StickyButton from "@/common/StickyButton";
import photoAfter from "@/female/assets/social-proof/female_review_after.webp";
import photoBefore from "@/female/assets/social-proof/female_review_before.webp";
import i18n from "@/localization/i18next";
import { QuestionComponentProps } from "@/types/common";
import { useGender } from "@/utils/GenderProvider";

const review = {
    title: i18n.t("zing_truly_transformed"),
    quote: i18n.t("female_social_proof_review"),
    name: "Rivky",
};

const PromoSocialProof = ({ handleNext }: QuestionComponentProps) => {
    const { isFemale } = useGender();

    const onClick = () => {
        handleNext();
    };

    return (
        <div className="flex h-full flex-col justify-between">
            <div className="mb-6 text-white female:text-black">
                <div className="mb-[22px] text-zing-24-32 font-semibold">{review.title}</div>
                {isFemale && (
                    <div className="relative mb-6 grid gap-2">
                        <QuotesStartSvg className="absolute -top-[11px] left-0 -z-10 text-zing-neutral-cool-grey-800 female:text-zing-warm-tangerine-100" />
                        <div>{review.quote}</div>
                        <div className="text-zing-neutral-cool-grey-600">— {review.name}</div>
                        <QuotesEndSvg className="absolute bottom-0 right-0 -z-10 text-zing-neutral-cool-grey-800 female:text-zing-warm-tangerine-100" />
                    </div>
                )}
                <div className="relative grid grid-cols-2">
                    <img src={photoBefore} className="h-auto self-stretch" alt="photo before" />
                    <img src={photoAfter} className="h-auto self-stretch" alt="photo after" />
                    <div className="absolute bottom-4 left-[50%] flex -translate-x-[50%] gap-1 rounded-3xl bg-white py-1 pl-[5px] pr-2 text-zing-12-18 leading-[14px] text-black female:bg-black female:text-white">
                        <LogoSvg />
                        <div>{i18n.t("one_month_progress")}</div>
                    </div>
                </div>
            </div>
            <StickyButton
                onClick={onClick}
                className="animate-[appear_1000ms_cubic-bezier(0.4,_0,_0.2,_1)_2000ms_forwards] opacity-0"
            >
                {i18n.t("sounds_great")}
            </StickyButton>
        </div>
    );
};

export default PromoSocialProof;
